//退款管理
export default {
	//客服人员-新增-编辑
	customerServiceSaveOrUpdate: {
		url: '/ec-pc-api/qualityCheck/manage/customerService/saveOrUpdate',
		type: 'post'
	},
	//客服人员-删除
	customerServiceDel: {
		url: '/ec-pc-api/qualityCheck/manage/customerService/del',
		type: 'post'
	},
	//用户店铺权限下拉列表
	userStoreList: {
		url: '/ec-pc-api/qualityCheck/manage/userStoreList',
		type: 'get'
	},
	//下拉条件集合
	queryCriteriaList: {
		url: '/ec-pc-api/qualityCheck/manage/queryCriteriaList',
		type: 'get'
	},
	//组长权限-新增-编辑
	teamLeaderSaveOrUpdate: {
		url: '/ec-pc-api/qualityCheck/manage/teamLeader/saveOrUpdate',
		type: 'post'
	},
	//组长权限-删除
	teamLeaderDel: {
		url: '/ec-pc-api/qualityCheck/manage/teamLeader/del',
		type: 'get'
	},
	//检查项配置-新增
	projectConfigAdd: {
		url: '/ec-pc-api/qualityCheck/manage/projectConfig/save',
		type: 'post'
	},
	//检查项配置-编辑
	projectConfigUpdate: {
		url: '/ec-pc-api/qualityCheck/manage/projectConfig/update',
		type: 'post'
	},
	//检查项配置-删除
	projectConfigDel: {
		url: '/ec-pc-api/qualityCheck/manage/projectConfig/del',
		type: 'get'
	},
	//查询检查项配置(最新)
	projectConfigList: {
		url: '/ec-pc-api/qualityCheck/manage/projectConfig/list',
		type: 'get'
	},
	//质检初审-新增
	preliminaryReviewAdd: {
		url: '/ec-pc-api/qualityCheck/manage/preliminaryReview/saveOrUpdate',
		type: 'post'
	},
	//质检初审-删除
	preliminaryReviewDel: {
		url: '/ec-pc-api/qualityCheck/manage/preliminaryReview/del',
		type: 'get'
	},
	//质检初审-允许申诉
	preliminaryReviewAllowAppeals: {
		url: '/ec-pc-api/qualityCheck/manage/preliminaryReview/allowAppeals',
		type: 'get'
	},
	//质检初审-下拉列表-平台客服ID
	platCustomerIdList: {
		url: '/ec-pc-api/qualityCheck/manage/platCustomerIdList',
		type: 'get'
	},
	//质检初审-审核
	preliminaryReviewAudit: {
		url: '/ec-pc-api/qualityCheck/manage/preliminaryReview/audit',
		type: 'post'
	},
	//质检初审-动态分页
	preliminaryReviewSearch: {
		url: '/ec-pc-api/qualityCheck/manage/preliminaryReview/search',
		type: 'post'
	},
	//质检初审-动态分页-导出
	preliminaryReviewExport: {
		url: '/ec-pc-api/qualityCheck/manage/preliminaryReview/export',
		type: 'post'
	},
	//查询质检信息的检查项配置
	projectConfigListSearch: {
		url: '/ec-pc-api/qualityCheck/manage/projectConfig/list',
		type: 'get'
	},
	//质检复审-动态分页
	secondReviewSearch: {
		url: '/ec-pc-api/qualityCheck/manage/secondReview/search',
		type: 'post'
	},
	//质检复审-动态分页-导出
	secondReviewExport: {
		url: '/ec-pc-api/qualityCheck/manage/secondReview/export',
		type: 'post'
	},
	//质检复审-编辑
	secondReviewUpdate: {
		url: '/ec-pc-api/qualityCheck/manage/secondReview/update',
		type: 'post'
	},
	//客服申诉-申诉
	customerServiceAppeal: {
		url: '/ec-pc-api/qualityCheck/manage/customerService/appeal',
		type: 'post'
	},
	//客服申诉-动态分页
	customerServiceSearch: {
		url: '/ec-pc-api/qualityCheck/manage/customerService/search',
		type: 'post'
	},
	//客服申诉-动态分页-导出
	customerServiceExport: {
		url: '/ec-pc-api/qualityCheck/manage/customerService/export',
		type: 'post'
	},
	//质检汇总表-动态分页
	summaryInfoSearch: {
		url: '/ec-pc-api/qualityCheck/manage/summaryInfo/search',
		type: 'post'
	},
	//质检汇总表-动态分页-导出
	summaryInfoExport: {
		url: '/ec-pc-api/qualityCheck/manage/summaryInfo/export',
		type: 'post'
	},
	//质检分析-岗位数据分析-动态分页
	workjobsSearch: {
		url: '/ec-pc-api/qualityCheck/manage/analysis/workjobs/search',
		type: 'post'
	},
	//质检分析-岗位数据分析-动态导出
	workjobsExport: {
		url: '/ec-pc-api/qualityCheck/manage/analysis/workjobs/export',
		type: 'post'
	},
	//质检分析-违规排名-动态分页
	violationRankingSearch: {
		url: '/ec-pc-api/qualityCheck/manage/analysis/violationRanking/search',
		type: 'post'
	},
	//质检分析-违规排名-动态导出
	violationRankingExport: {
		url: '/ec-pc-api/qualityCheck/manage/analysis/violationRanking/export',
		type: 'post'
	},
	//质检分析-违规占比-动态分页
	violationRatioSearch: {
		url: '/ec-pc-api/qualityCheck/manage/analysis/violationRatio/search',
		type: 'post'
	},
	//质检分析-违规占比-动态导出
	violationRatioExport: {
		url: '/ec-pc-api/qualityCheck/manage/analysis/violationRatio/export',
		type: 'post'
	},
	// 获取组织机构树
	yoLinkOrganTree: {
		url: `/ec-pc-api/yoLink/config/organ/tree`,
		type: 'get',
	  },
	// // 获取机构下用户信息
	// yoLinkOrganUserInfo: {
	// 	url: `/ec-pc-api/yoLink/config/organ/userInfo`,
	// 	type: 'post',
	//   },
	//消息通知配置-编辑
	yoLinkConfigUpdate: {
		url: '/ec-pc-api/yoLink/config/update',
		type: 'post'
	},
	//获取机构下用户信息
	yoLinkOrganUserInfo: {
		url: '/ec-pc-api/yoLink/config/organ/userInfo',
		type: 'post'
	},
	//检查项配置-启用-停用
	projectConfigUpdateStatus: {
		url: '/ec-pc-api/qualityCheck/manage/projectConfig/updateStatus',
		type: 'get'
	},
	//检查项配置-删除
	projectConfigDel: {
		url: '/ec-pc-api/qualityCheck/manage/projectConfig/del',
		type: 'get'
	},
	//质检登记查询
	registerPage: {
		url: '/ec-pc-api/qualityRegister/register/page',
		type: 'post'
	},
	//查询质检配置
	queryQualityConfigItem: {
		url: '/ec-pc-api/qualityRegister/register/queryQualityConfigItem',
		type: 'post'
	},
	//质检登记保存修改
	registerUpdate: {
		url: '/ec-pc-api/qualityRegister/register/saveQrUpdate',
		type: 'post'
	},
	//质检登记删除
	registerDel: {
		url: '/ec-pc-api/qualityRegister/register/delete',
		type: 'post'
	},
	//质检审核tab数字统计
	registerStatics: {
		url: '/ec-pc-api/qualityRegister/register/statics',
		type: 'post'
	},
	//质检审核
	registerAudit: {
		url: '/ec-pc-api/qualityRegister/register/audit',
		type: 'post'
	},
	//申诉审核状态查询
	queryAppealStatus: {
		url: '/ec-pc-api/qualityRegister/register/queryAppealStatus',
		type: 'get'
	},
	//查询申诉操作记录
	queryQualityRegisterLog: {
		url: '/ec-pc-api/qualityRegister/register/queryQualityRegisterLog',
		type: 'get'
	},
	//列表查询
	qualityAuditConfigPage: {
		url: '/ec-pc-api/qualityAuditConfig/query',
		type: 'get'
	},
	//保存
	qualityAuditConfigSave: {
		url: '/ec-pc-api/qualityAuditConfig/save',
		type: 'post'
	},
}